import React, {useEffect} from 'react'
import './land.css'
import Banner from '../../components/Banner/Banner'
import Download from '../../components/download/Download'
import Footer from '../../components/footer/Footer'
import Header from '../../components/Header/Header';
import { useStateValue } from '../../stateprovider';

import Testi from '../../components/Testimonial/testi'

const Land = () => {
  const [{ menu }, dispatch] = useStateValue();

  useEffect(()=>{
      dispatch({
          type: "MENU",
          menu: false
      });
      dispatch({
          type:"ACTIVE_NAVIGAtION",
          navigation: 'Home'
      });

  },[])
  return (
    <>
      <section className='favdoc__land'>
      <Header />
      <>
        <Banner />
        <Testi />
        <Download />
  <Footer />
  
        </>
      </section>
    </>
  )
}

export default Land
